const ADD = 'Add';
const CLICK = 'Click';
const JOIN = 'Join';
const VIEW = 'View';
const COPY = 'Copy';

export default class Action {
  static get ADD() {
    return ADD;
  }
  static get CLICK() {
    return CLICK;
  }

  static get VIEW() {
    return VIEW;
  }

  static get JOIN() {
    return JOIN;
  }

  static get COPY() {
    return COPY;
  }

  static values() {
    return [ADD, VIEW, JOIN, CLICK];
  }
}
